import { calculateFinances, UserData, formatRupeeLiteral } from "../../../constants";

const SummaryWhy2 = {
  label: 'Why Invest',
  hide: true,
  sections: [
    {
      type: 'text',
      text: (data: UserData) => {
        const taxData = calculateFinances(data);
        return `
        <h5>${
          data.firstName ? `${data.firstName}, ` : ''
          } Make up to Rs. ${formatRupeeLiteral(Math.round(taxData.everything))} in ${
          taxData.aggressiveYears
          } Years!</h5>
        <div class="sunshine-block">
          <ul>
            <li><label>Age</label><span>${data.age}</span></li>
            <li><label>Income</label><span>Rs. ${data.income.toLocaleString(
            'en-IN'
          )}</span></li>
            <li><label>Tax Savings</label><span>Rs. ${data.investments80C.toLocaleString(
            'en-IN'
          )}</span></li>
            ${
          data.married
            ? `<li><label>Marital Status</label><span>${
            data.married
            }</span></li>`
            : ''
          }
            ${
          data.deduction80DInsurance
            ? `<li><label>Health Insurance</label><span>${
            data.deduction80DInsurance
            }</span></li>`
            : ''
          }
            ${
          data.homeLoan
            ? `<li><label>Home Ownership</label><span>${
            data.homeLoan
            }</span></li>`
            : ''
          }
          </ul>
          <div class="analysis">
            We analyzed your data<br/>
            and can help you<br />
            grow your money up to<br/>
            <span>Rs. ${formatRupeeLiteral(taxData.everything)}</span><br />
          </div>
        </div>
        `;
      },
    },
  ]
}

export default SummaryWhy2;



// WEBPACK FOOTER //
// ./components/recommendation/cards/summaryWhy2.ts